import { themr } from '@friendsofreactjs/react-css-themr';

import InfoBox from './InfoBox';

export default themr('InfoBox')(InfoBox);
